export const DMCA_LINK = 'https://bsky.social/about/support/copyright'
